import React, { useState, useRef, useEffect } from "react";
import { Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { EsslData } from "../Slices/esslSlice";
import { CustomGridTable } from "../blueplanitUtils/CustomGridTable";
import AttendanceFilter from "./esslfilter";
import dayjs from "dayjs";
const Reportesl = () => {
  const dispatch = useDispatch();
  const filterRef = useRef();
 
  // Redux State
  const biometricData = useSelector((state) => state.esslData.biometric);
  const records = biometricData?.records || [];
  const totalCount = biometricData?.totalCount || 0;
  // Pagination State (Same as Finance)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });
 
  // Filter state (same pattern as finance)
  const [filterForm, setFilterForm] = useState({});
 
  // Convert timestamps
const formatMinutesToHM = (mins) => {
  if (mins == null) return "-";   // handles null/undefined
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  // pad with leading zeros
  const hh = String(h).padStart(2, "0");
  const mm = String(m).padStart(2, "0");
  return `${hh}:${mm}`;
};
 
  // Convert stored punch strings
  const convertPunchRecords = (str) => {
    if (!str) return [];
    const cleaned = str.trim().replace(/,$/, "");
    const entries = cleaned.split(",");
 
    return entries
      .map((entry) => {
        const parts = entry.split(":");
        if (parts.length < 3) return null;
 
        const [hh, mm, rawType] = parts;
        const time = `${hh}:${mm}`;
 
        const isValid = /^\d{1,2}:\d{2}$/.test(time);
        if (!isValid) return null;
 
        const date = new Date();
        date.setHours(Number(hh));
        date.setMinutes(Number(mm));
 
        return {
          time: date.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
          type: rawType.replace(/\(.*?\)/g, "").trim().toUpperCase(),
        };
      })
      .filter(Boolean);
  };
 
  // Process records before table
  const processedData = records.map((item, index) => ({
    ...item,
    sno: (pagination.current - 1) * pagination.pageSize + index + 1,
    punchRecords: convertPunchRecords(item.punchRecords),
    workDur: formatMinutesToHM(item.duration),
    otFormatted: formatMinutesToHM(item.overTime),
  }));
 
  // Initial Load
  useEffect(() => {
    dispatch(EsslData({ page: 1, pageSize: 50 }));
  }, [dispatch]);
 
  // Handle Filters
  const applyFilters = (filters) => {
    const newFilters = {
      employeeId: filters.ecode ? Number(filters.ecode) : null,
      employeeName: filters.employeeName || null,
      status: filters.status || null,
      shiftName: filters.shift || null,
      attendanceDate: filters.date || null,
      inTime: filters.inTime || null,
      outTime: filters.outTime || null,
      workDur: filters.workDur || null,
      ot: filters.ot || null,
      page: 1,
      pageSize: pagination.pageSize,
    };
 
    setFilterForm(newFilters);
    setPagination({ current: 1, pageSize: pagination.pageSize });
    dispatch(EsslData(newFilters));
  };
 
  // Pagination Handler (Same as Finance)
  const handlePageChange = (page, pageSize) => {
    setPagination({ current: page, pageSize });
 
    dispatch(
      EsslData({
        ...filterForm,
        page,
        pageSize,
      })
    );
  };
 
  // Punch Popover
  const PunchDetailsPopup = ({ punchRecords }) => (
    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
      {punchRecords.map((p, index) => (
        <div
          key={index}
          style={{
            borderBottom:
              index < punchRecords.length - 1 ? "1px dashed #ddd" : "none",
            padding: "4px 0",
            fontSize: 12,
          }}
        >
          {p.time} ({p.type})
        </div>
      ))}
    </div>
  );
 
  const PunchViewLink = ({ punchRecords }) => (
    <Popover
      placement="right"
      trigger="hover"
      content={<PunchDetailsPopup punchRecords={punchRecords} />}
      title="All Punches"
    >
      <span
        style={{
          color: "#1890ff",
          cursor: "pointer",
          fontSize: 10,
          textDecoration: "underline",
          whiteSpace: "nowrap",
        }}
      >
        View ({punchRecords.length})
      </span>
    </Popover>
  );
 
  // Columns
  const attendanceColumns = [
    {
      title: "S.No",
      width: 60,
      align: "center",
      dataIndex: "sno",
    },
    { title: "E. Code", dataIndex: "employeeId", width: 100 },
    { title: "Name", dataIndex: "employeeName", width: 150 },
    { title: "Shift", dataIndex: "shiftName", width: 80 },
    {
      title: "Date",
      width: 160,
      dataIndex: "attendanceDate",
      render: (text) => dayjs(text).format("DD-MM-YYYY hh:mm A"),
    },
    {
      title: "Punches",
      dataIndex: "punchRecords",
      width: 140,
      align: "center",
      render: (records) =>
        records && records.length ? (
          <PunchViewLink punchRecords={records} />
        ) : (
          "-"
        ),
    },
    { title: "Work Dur.", dataIndex: "workDur", width: 100 },
    { title: "OT", dataIndex: "otFormatted", width: 80 },
    {title: "In Time", dataIndex: "shiftInTime", width: 80,},
    {title: "Out Time", dataIndex: "shiftOutTime", width: 80,},
    {title: "Attendance Status", dataIndex: "attendanceStatus", width: 120, align: "center",},
   {
  title: "Status",
  dataIndex: "status",
  width: 100,
  render: (text) => {
    let color = "black";
    let label = text;
 
    if (!text || text.toLowerCase() === "absent") {
      color = "red";
      label = "Absent";
    } else if (text.toLowerCase() === "present ") {
      color = "green";
      label = "Present";
    }
 
    return <span style={{ color }}>{label}</span>;
  },
}
 
  ];
 
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
 
        <AttendanceFilter ref={filterRef} onFilter={applyFilters} />
 
        <CustomGridTable
          Id="AttendanceReportTable"
          columns={attendanceColumns}
          dataSource={processedData}
          rowKey="sno"
          scroll={{ x: "max-content", y: 600 }}
          bordered
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: totalCount,
            onChange: handlePageChange,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            showSizeChanger: false,
            showQuickJumper: true,
          }}
        />
      </div>
    </div>
  );
};
 
export default Reportesl;
 